<template>
    <div>
        <section>
            <v-card-actions>
                <router-link to="/courses">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo 
            
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!----> 
                    <details @click="mostrarAdjuntosCategories(4)" open>
                        <summary id="cat3">
                            <p><b>E-learning</b></p>
                        </summary>
                        <div>
                            <p>
                                <a href="https://learn.unoct-connectandlearn.org/" target="_blank">UNOCT’s Connect & Learn platform</a> offers capacity building to relevant 
                                stakeholders through modules and training courses tailored specifically to programmatic activities. The platform is designed to continuously be 
                                refreshed with new courses, new beneficiaries, and new resources to support Member States and beyond in fulfilling the UN Global 
                                Counter-Terrorism Strategy. Courses on offer include, inter alia, the 
                                <a href="https://learn.unoct-connectandlearn.org/course/index.php?categoryid=47" target="_blank">
                                United Nations on Counter-Terrorism (CT) and the Prevention and Countering of Violent Extremism (P/CVE) Architecture</a>, 
                                <a href="https://learn.unoct-connectandlearn.org/course/index.php?categoryid=25" target="_blank">
                                UN Countering Terrorist Travel Programme, Preventing and Responding to WMD/CBRN Terrorism</a>.
                            </p>
                            <p>
                                UNODC has developed numerous training courses and e-learning modules available through the 
                                <a href="http://www.unodc.org/elearning/en/index.html" target="_blank">UNODC Global eLearning Programme</a>. These include: <br><br>

                                <b>1 The International Legal Framework Against CBRN Terrorism</b><br>
                                This self-paced module intends to familiarize you with the international legal framework against Chemical, Biological, Radiological and 
                                Nuclear (CBRN) Terrorism, legal obligations established by these instruments and mutual interactions between them.<br>
                                Available in: 
                                <a href="https://golearn.unodc.org/lms/course/view.php?id=412" target="_blank">English</a> - 
                                <a href="https://golearn.unodc.org/lms/course/view.php?id=439" target="_blank">French</a> - 
                                <a href="https://golearn.unodc.org/lms/course/view.php?id=438" target="_blank">Spanish</a> - Duration: 60 min.<br><br>

                                <b>2 Countering the Financing of Terrorism and Proliferation of WMDs by non-State actors</b><br>
                                This course makes you understand the various financing schemes used by terrorist organisations to raise the funds and what are the 
                                appropriate measures to prevent terrorist fundraising, seize terrorist funds, and, in the process, make it very difficult for a terrorist 
                                organization to survive.<br>
                                Available in: English - Duration: 40 min.<br>
                            </p>
                            <p>
                                In addition, the <a href="https://ctlp.unodc.org/login/index.php" target="_blank">UNODC Counter-Terrorism Learning Platform</a> is an interactive 
                                tool specifically designed to assist criminal justice officers with enhancing their capacities in the fight against terrorism. 
                            </p>
                        </div>
                    </details>
                </v-col>
            </v-row>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 9,
                    title: 'TERRORISM PREVENTION',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat1" style="text-decoration: none;">9.1. UN actors</a></li>'+
                            '<li><a href="#cat2" style="text-decoration: none;">9.2. Thematic Areas</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat2_1" style="text-decoration: none;">9.2.1. Legislation</a></li>'+
                                    '<li><a href="#cat2_2" style="text-decoration: none;">9.2.2. Capacity-building</a></li>'+
                                    '<li><a href="#cat2_3" style="text-decoration: none;">9.2.3. Human Rights</a></li>'+
                                    '<li><a href="#cat2_4" style="text-decoration: none;">9.2.4. Policy and Strategy</a></li>'+
                                    '<li><a href="#cat2_5" style="text-decoration: none;">9.2.5. UN Resolutions</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat3" style="text-decoration: none;">9.3. E-learning</a></li>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'Latin American and Caribbean (LAC) countries are not immune to terrorism. Recent evidence indicates that criminal organizations may be adopting tactics similar to those associated with terrorist organizations and that new trends and cells inspired by violent extremism conducive to terrorism have surfaced in the region.'+
                    '<br><br>The connection between terrorism and criminal activities has grown stronger, more effective, and more prevalent in certain parts of the Americas. States have recognized the threat posed by terrorism and have gradually introduced measures to prevent terrorist acts and the movement of terrorists across borders.'+
                    '<br><br>More needs to be done especially regarding emerging terrorist threats, whether on critical infrastructure, environmental terrorism, new forms of violent extremism, financing of terrorism, nuclear terrorism and addressing the nexus between terrorism and transnational organized crime in the LAC region and its impact around the world.',
                    description: '',                    
                    images: ['9.jpg'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarTerrorism/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarTerrorism/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte9/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte9/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesTerrorism/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }    
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
</style>